import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const CoinNewsStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 600,
      textDecoration: "underline",
      wordBreak: "break-word",
    },
    source: {
      fontSize: "14px",
      fontStyle: "normal",
      fontFamily: "Söhne",
      fontWeight: 400,
      color: theme.palette.text.primary,
      alignItems: "flex-end",
    },
    card: {
      border: "none",
      boxShadow: "none",
      width: "auto",
      padding: "12px",
      [theme.breakpoints.between(1300, 1800)]: {
        maxWidth: "210px",
      },
      [theme.breakpoints.between(1000, 1300)]: {
        maxWidth: "235px",
      },
      [theme.breakpoints.between(600, 1000)]: {
        maxWidth: "270px",
        minWidth: "180px",
      },
    },
  }),
);
